import { Expose } from 'class-transformer';
import { SurveyElement } from './element';

export class SurveyTextElement extends SurveyElement {
  @Expose()
  text!: string;
}
